import _ from "underscore";
import {datadogLogs} from "@datadog/browser-logs";

export default (method, errors, customError) => {
    let error_message = method + ' - ';
    if(_.isArray(errors)){
        error_message += JSON.stringify(_.pluck(errors, 'message'));
    } else if (_.isObject(errors)) {
        error_message += errors.message || errors.error || errors.detail || errors.details;
    } else {
        error_message += errors;
    }

    if (customError) {
        error_message += ' - Custom Error Message - ' + JSON.stringify(customError);
    }

    let request_body = JSON.stringify(errors);
    if(errors.request_body){
        request_body = errors.request_body;
    }

    let response_body = {};
    if(errors.response_body){
        response_body = errors.response_body;
    }

    if(errors.response){
        request_body = errors.request.apiCall || errors.response.headers;
        response_body = errors.response.data;
    }

    datadogLogs.logger.error(
        error_message,
        {
            request_body: request_body,
            response_body: response_body
        }
    );
}